import $ from 'jquery';
import 'slick-carousel';

const $homePage = $('.page-template-home');

if ($homePage.length > 0) {
  const testSlider = 'home-hero-slider';
  const $homeHeroLoadings = $('.hero-loadings');
  const homeBannerOptions = $('.home__hero-stack').data('banner-options');

  $(`.${testSlider}`).on('init beforeChange', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.controls-dots-${testSlider}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
      $homeHeroLoadings.each(function () {
      $(this).removeClass('opacity-0');
    });

  });

  const heroSliderOptions = {
    lazyLoad: 'progressive',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    adaptiveHeight: true,
    appendDots: $(`.controls-dots-${testSlider}`),
    nextArrow: $(`.controls-next-${testSlider}`),
    prevArrow: $(`.controls-prev-${testSlider}`),
  };

  if ($homePage.length != 0 && homeBannerOptions && homeBannerOptions.autoscroll == true) {
    heroSliderOptions.autoplay = true;
    heroSliderOptions.autoplaySpeed = homeBannerOptions.duration_interval ?? 8000;
  }

  $(`.${testSlider}`).slick(heroSliderOptions);
   $(`.${testSlider}`).on('init postChange', function (event, slick) {
    slick.setPosition();
  });  

}
